/**
 * Utility functions for building bedroom options in property search filters
 */

/**
 * Builds an array of bedroom options from 1 to max bedrooms
 * @param {number} max - Maximum number of bedrooms
 * @returns {Array<{value: string, label: string}>} Array of bedroom options
 */
export const buildBedroomOptions = (max) => {
  const options = [];
  for (let i = 1; i <= max; i++) {
    if (i === max) {
      options.push({ value: String(i), label: `${i}+` });
    } else {
      options.push({ value: String(i), label: String(i) });
    }
  }
  return options;
};
